// extracted by mini-css-extract-plugin
export default {"text":"Impressum_text__uSEi+"};